export default "__VITE_ASSET__8kP3yL54__"